export * from './recommendations-table'
